



























































import { Component, Prop } from "vue-property-decorator";
import _ from "lodash";

import AppVue from "@/AppVue.vue";
import { ParticipantModel } from "@/core/models";
import { CompanyService, UserService } from "@/core/services";
import { GridTableCpt } from "@/core/components";

@Component({
  components: {
    GridTableCpt,
  },
})
export default class WorkshopParticipantsAttendanceGridCpt extends AppVue {
  @Prop() workshopId: number;

  updating = false;
  loading = false;
  model = [] as ParticipantModel[];
  search = "";

  columns = [
    { label: "Participant Name", prop: "fullName", slot: "fullName", width: "150px", sortable: true },
    { label: "Email", prop: "email", slot: "email", width: "150px", sortable: true },
    { label: "Client Name", prop: "companyName", slot: "companyName", width: "150px", sortable: true },
    { label: "Client Sector", prop: "companySectorName", slot: "companySectorName", width: "150px", sortable: true },
    { label: "Attended?", prop: "attended", slot: "attended", width: "50px", sortable: false },
  ];

  async created() {
    this.initializeModel();
  }

  private async updateAttendance(participant: ParticipantModel) {
    this.updating = true;
    try {
      await UserService.updateAttendance(participant.userId, this.workshopId, participant.hasAttended);
      this.$emit("participant-updated", participant);
      this.initializeModel();
    } finally {
      this.updating = false;
    }
  }
  private async initializeModel() {
    this.loading = true;
    try {
      this.model = await CompanyService.getParticipants(this.workshopId);
    } finally {
      this.loading = false;
    }
  }
}
